import config from 'config';

import { MembershipRewardTierIdMapping } from '../../shared/constants/loyaltyTiers';
import { getBrandValue } from '../../shared/utils/brandNameHelper';
import { Gender } from '../../techstyle-shared/react-accounts';

export const getBuilderPageTargeting = (pageOptions = {}) => {
  const brand = config.get('public.brand.name');

  const {
    experienceId,
    gender,
    locale,
    tld,
    membershipStatus,
    isPreview,
    loyalty,
    vipPlusPerksAvailable,
    membershipPrice,
    isFirstBilling,
    developerDefinedTargetingId,
    options = {},
  } = pageOptions;

  const queryGender = gender === Gender.MALE ? 'male' : 'female';
  /* original/final implementation, 
  but for PROD testing we use the reward_tier_level_id and map them to the corresponding labels for our test countries
  ////////// enable the following line again:
  const loyaltyTierLabel = loyalty?.tier?.label;
  //////////
  remove that after new Loyalty program launch */
  const loyaltyRewardTierId = loyalty?.tier?.membershipRewardTierId;
  let loyaltyTierLabel =
    (locale === 'en-CA' ||
      locale === 'en-GB' ||
      locale === 'fr-FR' ||
      locale === 'es-ES' ||
      locale === 'nl-NL' ||
      locale === 'sv-SE' ||
      locale === 'da-DK') &&
    loyaltyRewardTierId in MembershipRewardTierIdMapping
      ? MembershipRewardTierIdMapping[loyaltyRewardTierId]
      : loyalty?.tier?.label;
  loyaltyTierLabel = loyaltyTierLabel?.length ? loyaltyTierLabel : null;
  /// remove the above

  /**
   * @description we want to ensure we are setting the `userAttributes.locale` based on the users `tld`.
   * Primary purpose for this is to ensure that en-EU is set for .eu, rather than en-GB, for SXF.
   */
  const userAttributesLocale = config.get('public.intl.builderLocales')[tld];
  // Build user attributes with generic fields
  const commonAttributes = {
    brand,
    experienceId,
    gender: queryGender,
    locale: userAttributesLocale,
    membershipStatus,
    platform: 'web',
    loyaltyTierLabel,
    vipPlusPerksAvailable: vipPlusPerksAvailable || false,
    isFirstBilling,
    developerDefinedTargetingId,
  };

  // Add brand-specific attributes
  const userAttributes = getBrandValue({
    default: {
      ...commonAttributes,
    },
    savage: {
      ...commonAttributes,
      tld,
      membershipPrice,
    },
  });

  return {
    userAttributes,
    options: {
      includeUnpublished: isPreview,
      ...options,
      locale,
    },
  };
};
